import React from 'react';
import classes from './Section5.module.css';

const section5=()=>{
    return (
        <div className={classes.Section5}>
            <h5>Contact : +91-7396676216</h5>
        </div>
    )
}

export default section5;